import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaModule } from 'ng-recaptcha';
import { RECAPTCHA_BASE_URL } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { PublicComponent } from './contractor.component';
import {
  ContractorRoutingModule,
  COMPONENTS,
} from './contractor-routing.module';
import {
  CompanyEditModalComponent,
  LoginModalComponent,
  UploadDocumentModalComponent,
  UploadProofOfPaymentModalComponent,
} from './modals';
import { PublicSidebar } from './contractor-sidebar';
import { UserAccountComponent } from './components/user-account/user-account.component';
import { environment } from 'src/environments/environment';
import { PaymentReviewModalComponent } from './modals/payment-preview-modal/payment-preview.component';
import { PrintSlipModalComponent } from './modals/print-slip-modal/print-slip-modal.component';
import { TenderPaymentModalComponent } from './modals/tender-payemnt-modal/tender-payment.component';
const ENTRY_COMPONENT: Array<any> = [
  CompanyEditModalComponent,
  UploadDocumentModalComponent,
  UploadProofOfPaymentModalComponent,
  PaymentReviewModalComponent,
  PrintSlipModalComponent,
  TenderPaymentModalComponent,
  LoginModalComponent,
];
@NgModule({
  declarations: [
    ...COMPONENTS,
    PublicComponent,
    ...ENTRY_COMPONENT,
    PublicSidebar,
    UserAccountComponent,
    PaymentReviewModalComponent,
    PrintSlipModalComponent,
    TenderPaymentModalComponent,
    LoginModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ContractorRoutingModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  entryComponents: [...ENTRY_COMPONENT],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.siteKey } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_BASE_URL,
      useValue: 'https://recaptcha.net/recaptcha/api.js', // use recaptcha.net script source for some of our users
    },
  ],
})
export class PublicModule {}
